import { Component } from "@angular/core";
import { UserAuthenticationService } from  "../../../services/shared/userAuthentication.service";

@Component({
    selector: "footer-component",
    template: require("./footer.component.html"),
    styles: [require("./footer.component.less").toString()]
})

export class FooterComponent {
    version: string;
    constructor(public userAuthService: UserAuthenticationService) {
        this.version  = "2.0.0.1";
    }

    public logout() {
        this.userAuthService.Logout();
    }
} 


// WEBPACK FOOTER //
// ./src/app/components/shared/footer/footer.component.ts